{{#each children}}
<li>
    <span class="lie-item"><span class="lie-itemtype">{{definition.ItemType}}</span> (<span class="lie-itemyear">{{definition.TaxYear}}</span>)</span>
    {{#if children}}
    <ul>
        {{> GEN1_TaxDist_LIE_TreeNode }}
    </ul>
    {{/if}}
</li>
{{/each}}